import { render, staticRenderFns } from "./PendenciesDetails.vue?vue&type=template&id=1474b033"
import script from "./PendenciesDetails.vue?vue&type=script&lang=js"
export * from "./PendenciesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports